import { render, staticRenderFns } from "./LearningDashboard.vue?vue&type=template&id=23ec8b3d&scoped=true"
import script from "./LearningDashboard.vue?vue&type=script&lang=js"
export * from "./LearningDashboard.vue?vue&type=script&lang=js"
import style0 from "./LearningDashboard.vue?vue&type=style&index=0&id=23ec8b3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ec8b3d",
  null
  
)

export default component.exports